import { useFeatureIsOn } from '@growthbook/growthbook-react';
import useSearchAvailability from '../useSearchAvailability';

export const useShellNavigationOptions = () => {
  const { isSearchAvailable } = useSearchAvailability();
  const showSearchFeature = useFeatureIsOn('search-events-feature');

  return {
    showSearchEntry: showSearchFeature && isSearchAvailable,
  };
};
